import { svgPaths } from '../../imports/svgPaths';
import heroLogo from "../../image/hero-section/hero-logo.png";
// import.*from.*imports/svg-diyh21zxx2";
import heroConiPose3 from "../../image/hero-section/hero-coni-pose3.png";
import heroConiPose4 from "../../image/hero-section/hero-coni-pose4.png";
import heroConiPose2 from "../../image/hero-section/hero-coni-pose2.png";

// Hero Section Background with New Design
function Section() {
  return (
    <div
      className="absolute h-[100vh] min-h-[600px] left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] w-full"
      data-name="Section"
    >
      {/* New Background Design */}
      <div className="absolute contents left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%]">
        {/* Main Gradient Background */}
        <div className="absolute bg-gradient-to-b from-[#ffd844] from-[5.564%] h-[2160px] left-1/2 to-[#d4a533] to-[55.723%] top-1/2 translate-x-[-50%] translate-y-[-50%] w-[3840px]" />
        
        {/* Character 1 - Top Right */}
        <div
          className="absolute flex h-[572.497px] items-center justify-center translate-x-[-50%] translate-y-[-50%] w-[572.497px]"
          style={{ top: "calc(50% + 84.446px)", left: "calc(50% + 345.286px)" }}
        >
          <div className="flex-none rotate-[348.902deg]">
            <div
              className="bg-center bg-cover bg-no-repeat size-[487.746px]"
              data-name="Coni_Pose3"
              style={{ backgroundImage: `url('${heroConiPose3}')` }}
            />
          </div>
        </div>
        
        {/* Wave Shape 1 */}
        <div
          className="absolute h-[1034px] left-1/2 translate-x-[-50%] translate-y-[-50%] w-[3840px]"
          style={{ top: "calc(50% + 105.072px)" }}
        >
          <svg
            className="block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 3840 1034"
          >
            <path
              clipRule="evenodd"
              d={svgPaths.pef1da00}
              fill="url(#paint0_linear_15_101)"
              fillRule="evenodd"
              id="Vector 4"
            />
            <defs>
              <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint0_linear_15_101"
                x1="1920"
                x2="1920"
                y1="0"
                y2="1034"
              >
                <stop offset="0.202891" stopColor="#FFD844" />
                <stop offset="0.987899" stopColor="#D4A533" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        
        {/* Character 2 - Right */}
        <div
          className="absolute flex h-[561.193px] items-center justify-center translate-x-[-50%] translate-y-[-50%] w-[561.193px]"
          style={{ top: "calc(50% + 170.071px)", left: "calc(50% + 677.572px)" }}
        >
          <div className="flex-none rotate-[350.55deg]">
            <div
              className="bg-center bg-cover bg-no-repeat size-[487.746px]"
              data-name="Coni_Pose4"
              style={{ backgroundImage: `url('${heroConiPose4}')` }}
            />
          </div>
        </div>
        
        {/* Wave Shape 2 */}
        <div
          className="absolute h-[726px] left-1/2 translate-x-[-50%] translate-y-[-50%] w-[3840px]"
          style={{ top: "calc(50% + 354.072px)" }}
        >
          <svg
            className="block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 3840 726"
          >
            <path
              d={svgPaths.pdf82600}
              fill="url(#paint0_linear_15_99)"
              id="Vector 3"
            />
            <defs>
              <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint0_linear_15_99"
                x1="1920"
                x2="1920"
                y1="0"
                y2="726"
              >
                <stop offset="0.188432" stopColor="#FFD844" />
                <stop offset="0.885624" stopColor="#D4A533" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        
        {/* Character 3 - Bottom Center */}
        <div
          className="absolute flex h-[520.797px] items-center justify-center translate-x-[-50%] translate-y-[-50%] w-[520.797px]"
          style={{ top: "calc(50% + 419.528px)", left: "calc(50% + 366.12px)" }}
        >
          <div className="flex-none rotate-[4.029deg]">
            <div
              className="bg-center bg-cover bg-no-repeat size-[487.746px]"
              data-name="Coni_Pose2"
              style={{ backgroundImage: `url('${heroConiPose2}')` }}
            />
          </div>
        </div>
        
        {/* Wave Shape 3 */}
        <div
          className="absolute h-[621px] left-1/2 translate-x-[-50%] translate-y-[-50%] w-[3840px]"
          style={{ top: "calc(50% + 679.572px)" }}
        >
          <svg
            className="block size-full"
            fill="none"
            preserveAspectRatio="none"
            viewBox="0 0 3840 621"
          >
            <path
              d={svgPaths.p20bbe7f2}
              fill="url(#paint0_linear_15_97)"
              id="Vector 2"
            />
            <defs>
              <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint0_linear_15_97"
                x1="1920"
                x2="1920"
                y1="0"
                y2="621"
              >
                <stop offset="0.0470012" stopColor="#FFD844" />
                <stop offset="0.797037" stopColor="#D4A533" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </div>
    </div>
  );
}

// Hero Logo and Title Container
function Container1() {
  return (
    <div
      className="box-border content-stretch flex flex-col gap-2 items-end justify-end opacity-80 p-0 relative shrink-0"
      data-name="Container"
    >
      <div
        className="bg-center bg-contain bg-no-repeat h-[min(150px,_18vw)] mix-blend-soft-light opacity-80 shrink-0 w-[min(688px,_80vw)]"
        data-name="벅스_로고 단색 (1)"
        style={{ backgroundImage: `url('${heroLogo}')` }}
      />

    </div>
  );
}

// Hero Title Section
function Section1() {
  return (
    <div
      className="absolute box-border content-stretch flex flex-col gap-10 items-start justify-start left-1/2 pb-0 pt-20 px-4 top-1/2 translate-x-[-50%] translate-y-[-50%] w-[min(1280px,_calc(100vw_-_40px))]"
      data-name="Section"
    >
      <Container1 />
      <div
        className="font-paperlogy font-bold leading-[normal] min-w-full not-italic relative shrink-0 text-[min(48px,_8vw)] text-[rgba(0,0,0,0.9)] text-left tracking-[-0.96px]"
        style={{ width: "min-content" }}
      >
        <p className="block mb-0 font-bold text-[rgba(255,255,255,0.6)]">창의력을 깨우는</p>
        <p className="block font-bold text-[rgba(255,255,255,0.6)]">어린이 디지털 놀이공간</p>
      </div>
    </div>
  );
}

// Main Hero Container
function MainContainer() {
  return (
    <div
      className="bg-[#ffd844] h-[70vh] sm:h-[80vh] md:h-[90vh] lg:h-[100vh] min-h-[500px] sm:min-h-[550px] md:min-h-[600px] max-h-[1080px] overflow-hidden relative shrink-0 w-full"
      data-name="Main Container"
    >
      <Section />
      <Section1 />
    </div>
  );
}

export function HeroSection() {
  return (
    <div
      id="hero-section"
      className="box-border content-stretch flex flex-col items-start justify-center p-0 relative shrink-0 w-full"
      data-name="Main Container"
    >
      <MainContainer />
    </div>
  );
}